// import { Typography } from '@mui/material';
import Typography from '@/components/shared/typography/typography.component';
import styles from './styles.module.scss';
import { ReactNode } from 'react';
import colors from '@/theme/colors.module.scss';
import { IVariant } from '@/components/shared/typography/typography.types';

interface ComponentProps {
  children?: ReactNode;
}
interface CustomTypographyProps extends ComponentProps {
  variant?: IVariant;
}
const CarProfileInfoContainer = ({ children }: ComponentProps) => {
  return <div className={styles.CarProfileInfoContainer}>{children}</div>;
};

const CarProfileCarName = ({ children, variant }: CustomTypographyProps) => {
  return (
    <Typography className={styles.CarProfileCarName} variant={variant}>
      {children}
    </Typography>
  );
};
const CarProfileTrim = ({ children, variant }: CustomTypographyProps) => {
  return (
    <Typography className={styles.CarProfileTrim} variant={variant} color={colors.gray500}>
      {children}
    </Typography>
  );
};

const CarProFileMoreInfoContainer = ({ children }: ComponentProps) => {
  return <div className={styles.CarProFileMoreInfoContainer}>{children}</div>;
};
const CarProFileMoreInfoItemContainer = ({ children }: ComponentProps) => {
  return <div className={styles.CarProFileMoreInfoItemContainer}>{children}</div>;
};

const CarProfileMoreInfoText = ({ children, variant }: CustomTypographyProps) => {
  return (
    <Typography className={styles.CarProfileMoreInfoText} variant={variant}>
      {children}
    </Typography>
  );
};
const CarProfileCarPrice = ({ children, variant }: CustomTypographyProps) => {
  return (
    <Typography className={styles.CarProfileCarPrice} variant={variant}>
      {children}
    </Typography>
  );
};

const CarProfileCurrency = ({ children, variant }: CustomTypographyProps) => {
  return (
    <Typography className={styles.CarProfileCurrency} variant={variant}>
      {children}
    </Typography>
  );
};

const CarProfileSubtitle = ({ children, variant }: CustomTypographyProps) => {
  return (
    <Typography className={styles.Subtitle} variant={variant}>
      {children}
    </Typography>
  );
};

const CarProfileInstallmentPrice = ({ children, variant }: CustomTypographyProps) => {
  return (
    <Typography className={styles.CarProfileInstallmentPrice} variant={variant}>
      {children}
    </Typography>
  );
};

export {
  CarProfileInfoContainer,
  CarProfileCarName,
  CarProfileTrim,
  CarProFileMoreInfoContainer,
  CarProFileMoreInfoItemContainer,
  CarProfileMoreInfoText,
  CarProfileCarPrice,
  CarProfileCurrency,
  CarProfileSubtitle,
  CarProfileInstallmentPrice,
};
